export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "중대시민재해 대상시설 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/685/page",
        name: "소관 시설 현황",
        slug: "",
        icon: "w-line",
      },
      {
        url: "/",
        name: "공중이용시설",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/field/library",
            name: "도서관",
            icon: "w-line",
            activeCode: "field-library",
          },
          {
            url: "/field/museum",
            name: "박물관 및 미술관",
            icon: "w-line",
            activeCode: "field-museum",
          },
          {
            url: "/field/medical",
            name: "의료기관",
            icon: "w-line",
            activeCode: "field-medical",
          },
          {
            url: "/field/daycare",
            name: "어린이집",
            icon: "w-line",
            activeCode: "field-daycare",
          },
          {
            url: "/field/office",
            name: "업무시설",
            icon: "w-line",
            activeCode: "field-office",
          },
          {
            url: "/field/indoor-auditorium",
            name: "실내공연장",
            icon: "w-line",
            activeCode: "field-indoor-auditorium",
          },
          {
            url: "/field/mixed-use-building",
            name: "둘이상용도건축물",
            icon: "w-line",
            activeCode: "field-mixed-use-building",
          },
          {
            url: "/field/building",
            name: "건축물",
            icon: "w-line",
            activeCode: "field-building",
          },
          {
            url: "/field/port",
            name: "항만(방파제)",
            icon: "w-line",
            activeCode: "field-port",
          },
          {
            url: "/field/port-dock",
            name: "항만(부두)",
            icon: "w-line",
            activeCode: "field-port-dock",
          },
          {
            url: "/field/bridge",
            name: "교량",
            icon: "w-line",
            activeCode: "field-bridge",
          },
          {
            url: "/field/tunnel",
            name: "터널",
            icon: "w-line",
            activeCode: "field-tunnel",
          },
          {
            url: "/field/retaining-wall",
            name: "옹벽",
            icon: "w-line",
            activeCode: "field-retaining-wall",
          },
          {
            url: "/field/cutting-slope",
            name: "절토사면",
            icon: "w-line",
            activeCode: "field-cutting-slope",
          },
        ]
      },
      {
        name: "원료·제조물",
        icon: "w-line",
        submenu: [
          {
            url: "/field/mass_feeding_facility",
            name: "집단급식소",
            icon: "w-line",
            activeCode: "field-mass_feeding_facility",
          },
        ]
      }
    ]
  },
  {
    url: "/",
    name: "안전계획 수립",
    icon: "",
    activeCode: "",
    submenu: [
      {
        name: "공중이용시설",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/616",
            name: "도서관",
            icon: "w-line",
            activeCode: "",
            groupName: ["616"],
          },
          {
            url: "/tab/617",
            name: "박물관 및 미술관",
            icon: "w-line",
            activeCode: "",
            groupName: ["617"],
          },
          {
            url: "/tab/618",
            name: "의료기관",
            icon: "w-line",
            activeCode: "",
            groupName: ["618"],
          },
          {
            url: "/tab/619",
            name: "어린이집",
            icon: "w-line",
            activeCode: "",
            groupName: ["619"],
          },
          {
            url: "/tab/620",
            name: "업무시설",
            icon: "w-line",
            activeCode: "",
            groupName: ["620"],
          },
          {
            url: "/tab/621",
            name: "실내공연장",
            icon: "w-line",
            activeCode: "",
            groupName: ["621"],
          },
          {
            url: "/tab/622",
            name: "둘이상용도건축물",
            icon: "w-line",
            activeCode: "",
            groupName: ["622"],
          },
          {
            url: "/tab/623",
            name: "건축물",
            icon: "w-line",
            activeCode: "",
            groupName: ["623"],
          },
          {
            url: "/tab/624",
            name: "항만",
            icon: "w-line",
            activeCode: "",
            groupName: ["624"],
          },
          {
            url: "/tab/625",
            name: "교량",
            icon: "w-line",
            activeCode: "",
            groupName: ["625"],
          },
          {
            url: "/tab/626",
            name: "터널",
            icon: "w-line",
            activeCode: "",
            groupName: ["626"],
          },
          {
            url: "/tab/627",
            name: "옹벽 및 절토사면",
            icon: "w-line",
            activeCode: "",
            groupName: ["627"],
          },
        ]
      },
    ]
  },
  {
    url: "/",
    name: "안전·보건 확보 의무",
    icon: "",
    activeCode: "",
    submenu: [
      {
        name: "공중이용시설",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/628",
            name: "도서관",
            icon: "w-line",
            activeCode: "",
            groupName: ["628"],
          },
          {
            url: "/tab/629",
            name: "박물관 및 미술관",
            icon: "w-line",
            activeCode: "",
            groupName: ["629"],
          },
          {
            url: "/tab/630",
            name: "의료기관",
            icon: "w-line",
            activeCode: "",
            groupName: ["630"],
          },
          {
            url: "/tab/631",
            name: "어린이집",
            icon: "w-line",
            activeCode: "",
            groupName: ["631"],
          },
          {
            url: "/tab/632",
            name: "업무시설",
            icon: "w-line",
            activeCode: "",
            groupName: ["632"],
          },
          {
            url: "/tab/633",
            name: "실내공연장",
            icon: "w-line",
            activeCode: "",
            groupName: ["633"],
          },
          {
            url: "/tab/634",
            name: "둘이상용도건축물",
            icon: "w-line",
            activeCode: "",
            groupName: ["634"],
          },
          {
            url: "/tab/635",
            name: "건축물",
            icon: "w-line",
            activeCode: "",
            groupName: ["635"],
          },
          {
            url: "/tab/636",
            name: "항만",
            icon: "w-line",
            activeCode: "",
            groupName: ["636"],
          },
          {
            url: "/tab/637",
            name: "교량",
            icon: "w-line",
            activeCode: "",
            groupName: ["637"],
          },
          {
            url: "/tab/638",
            name: "터널",
            icon: "w-line",
            activeCode: "",
            groupName: ["638"],
          },
          {
            url: "/tab/639",
            name: "옹벽 및 절토사면",
            icon: "w-line",
            activeCode: "",
            groupName: ["639"],
          },
        ]
      },
      {
        name: "원료·제조물",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/614",
            name: "집단급식소",
            icon: "w-line",
            activeCode: "",
            groupName: ["614"],
          },
        ]
      }
    ]
  },
  {
    url: "/",
    name: "안전·보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/661",
        name: "(공중이용시설)안전보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["661"],
      },
      {
        url: "/tab/615",
        name: "(원료·제조물)안전보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["615"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/656",
        name: "교육 이수 계획 및 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["656"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 발생 및 조치현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        name: "공중이용시설",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/642",
            name: "도서관",
            icon: "w-line",
            activeCode: "",
            groupName: ["642"],
          },
          {
            url: "/tab/643",
            name: "박물관 및 미술관",
            icon: "w-line",
            activeCode: "",
            groupName: ["643"],
          },
          {
            url: "/tab/644",
            name: "의료기관",
            icon: "w-line",
            activeCode: "",
            groupName: ["644"],
          },
          {
            url: "/tab/645",
            name: "어린이집",
            icon: "w-line",
            activeCode: "",
            groupName: ["645"],
          },
          {
            url: "/tab/646",
            name: "업무시설",
            icon: "w-line",
            activeCode: "",
            groupName: ["646"],
          },
          {
            url: "/tab/647",
            name: "실내공연장",
            icon: "w-line",
            activeCode: "",
            groupName: ["647"],
          },
          {
            url: "/tab/648",
            name: "둘이상용도건축물",
            icon: "w-line",
            activeCode: "",
            groupName: ["648"],
          },
          {
            url: "/tab/649",
            name: "건축물",
            icon: "w-line",
            activeCode: "",
            groupName: ["649"],
          },
          {
            url: "/tab/650",
            name: "항만",
            icon: "w-line",
            activeCode: "",
            groupName: ["650"],
          },
          {
            url: "/tab/651",
            name: "교량",
            icon: "w-line",
            activeCode: "",
            groupName: ["651"],
          },
          {
            url: "/tab/652",
            name: "터널",
            icon: "w-line",
            activeCode: "",
            groupName: ["652"],
          },
          {
            url: "/tab/653",
            name: "옹벽 및 절토사면",
            icon: "w-line",
            activeCode: "",
            groupName: ["653"],
          },
        ]
      },
      {
        name: "원료·제조물",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/654",
            name: "집단급식소",
            icon: "w-line",
            activeCode: "",
            groupName: ["654"],
          },
        ]
      }
    ]
  },
  // 2024-04-09 : 대시보드로 이동하여 메뉴 삭제했음
  // https://app.clickup.com/t/86ep2ghh4
  //
  // {
  //   url: "/",
  //   name: "주요 시설물 관리현황",
  //   icon: "",
  //   activeCode: "",
  //   submenu: [
  //     {
  //       name: "공중이용시설",
  //       icon: "w-line",
  //       submenu: [
  //         {
  //           url: "/",
  //           name: "도서관",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "박물관 및 미술관",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "의료기관",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "어린이집",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "업무시설",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "실내공연장",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "둘이상용도건축물",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "건축물",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "항만",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "교량",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "터널",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //         {
  //           url: "/",
  //           name: "옹벽 및 절토사면",
  //           icon: "w-line",
  //           // activeCode: "field-facility",
  //           // groupName: [""],
  //         },
  //       ]
  //     },
  //     {
  //       name: "원료·제조물",
  //       icon: "w-line",
  //       submenu: [
  //         {
  //           url: "/",
  //           name: "집단급식소",
  //           icon: "w-line",
  //           // activeCode: "field-workplace-material",
  //           // groupName: ["99"],
  //         },
  //       ]
  //     }
  //   ]
  // },
  {
    url: "/",
    name: "안전·보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/613",
        name: "유해·위험요인 점검 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["613"],
      },
    ]
  },
  {
    url: "/",
    name: "중대시민재해예방 업무처리절차",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/454",
        name: "중대시민재해 발생시 대응 매뉴얼",
        activeCode: "filelibrary-454",
        icon: "w-line",
      },
      {
        url: "/filelibrary/455",
        name: "중대시민재해 예방 업무처리 매뉴얼",
        activeCode: "filelibrary-455",
        icon: "w-line",
      },
    ]
  },
  {
    url: "/",
    name: "재해발생보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/640",
        name: "중대시민재해 발생 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["640"],
      },
      {
        url: '/tab/641',
        name: '중대시민재해 조치 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['641'],
      },
      {
        url: "/tab/655",
        name: "재발방지계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["655"],
      },
    ],
  },
  {
    url: "/",
    name: "자료실",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/413",
        name: "안전·보건 점검",
        activeCode: "filelibrary-413",
        icon: "w-line",
        groupName: ["413"],
      },
      {
        url: "/filelibrary/418",
        name: "안전·보건 교육",
        activeCode: "filelibrary-418",
        icon: "w-line",
        groupName: ["418"],
      },
      {
        url: "/filelibrary/423",
        name: "관련 법령 등",
        activeCode: "filelibrary-423",
        icon: "w-line",
        groupName: ["423"],
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "안전보건관리책임자 지시사항",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/tab/612",
        name: "공지사항(팝업관리)",
        icon: "w-line",
        groupName: ["612"],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ['93'],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ['94'],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ['95'],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ['96'],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ['97'],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ['98'],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
];
